import { render, staticRenderFns } from "./EditAcc.vue?vue&type=template&id=1cc720dd&scoped=true&"
import script from "./EditAcc.vue?vue&type=script&lang=js&"
export * from "./EditAcc.vue?vue&type=script&lang=js&"
import style0 from "./EditAcc.vue?vue&type=style&index=0&id=1cc720dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc720dd",
  null
  
)

export default component.exports